export const createIntervals = () => {
  const timeouts: NodeJS.Timeout[] = [];

  const pushInterval = (f: () => void, time: number = 0) => {
    const t = setInterval(() => {
      f();
    }, time);

    timeouts.push(t);
  };

  const clearIntervals = () => {
    timeouts.forEach((t) => {
      clearInterval(t);
    });
    timeouts.length = 0;
  };

  return {
    pushInterval,
    clearIntervals,
  };
};
